import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import GuestDetails from 'components/GuestDetails';
import { guestProfilesSelector } from 'routes/selectors';

const mapStateToProps = createStructuredSelector({
  guestProfiles: guestProfilesSelector
});

export default connect(mapStateToProps)(GuestDetails);
